<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('Items.SurgeryBrandModelMaster.List')"
            :contenttext="$t('Items.SurgeryBrandModelMaster.TableHeaderContent')">
          </Headerlayout>
        </b-col>
      </b-row>

      <b-row class="py-3">
        <b-col>
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading" eheader="List" econtent="List"
                eimg="/src/assets/Img/icons/unitmaster.svg" @createNew="IsAdd" />
              <div class="table-width-80">
                <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines"
                  :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                  :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                  @row-click="RowClick" :exceldownload="true">
                  <template v-slot:Add>
                    <span class="add">
                      <AddButton @click="IsAdd()" :btnname="$t('btn.plusaddnew')" class="float-rights my-3">
                      </AddButton>
                    </span>
                  </template>
                  <template v-slot:exceldownload>
                    <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                      PageName="Surgery list" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                  </template>
                  <template v-slot:Status="{ data }">

                    <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                    <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                  </template>
                  <template v-slot:action="{ data }">
                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)" />
                  </template>
                </Tableview>
              </div>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading" eheader="Unit Master" econtent="Unit Master"
                eimg="/src/assets/Img/icons/unitmaster.svg" @createNew="IsAdd" />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in List">
                    <div class="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <p class="light-name">{{ item.Code }}</p>
                        <p class="name">{{ item.Name }}</p>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>

                          <OrangeStatus name="InActive" v-if="item.IsActive == '0'" />
                          <GreenStatus name="Active" v-if="item.IsActive == '1'" />
                        </div>
                        <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                      </div>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
          <SurgerMappingCreation v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
            @load="IsShow(), (showDialog = false)" @close="showDialog = false" @loaderhide="loading = false"
            @loadershow="loading = true" :OperationID="ObjOperationId" , :EntityId="EntityData.EntityId" />
        </b-col>
      </b-row>
    </b-container>

    <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
    <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
      :content="$t('confirmation.editcontent')" />
    <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="content" @yes="IsDelete(dataEdit)"
      @no="Deletemodel = false" />
    <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
    <ActivatedSuccessfully :visible="popup.activatepop" @ok="closetrigger()" />
    <InActivatedSuccessfully :visible="popup.inactivepop" @ok="closetrigger()" />
    <Mapping :content="ContentName" :visible="MappingPopup" @ok="closemapping()" />
  </div>
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, h, computed, onMounted, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import SurgerMappingCreation from "../../../Masters/Items/SurgeryBrandModel/SurgertBrandModelMappingCreation.vue";
import axios from "axios";
import service from "../../../../Service/SurgeryMappingService";

import { FilterMatchMode, FilterOperator } from "primevue/api";

import { useI18n } from 'vue-i18n';
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import Tableview from "../../../../../../components/FormComponents/Table.vue";

import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";
import MastersService from "../../../../Service/MastersService";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    Mapping,
    BacktoPage,
    Headerlayout,
    SurgerMappingCreation,
    axios,
    service,
    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },

  setup() {
    debugger;
    let MappingPopup = ref(false);
    let ContentName = ref("");
    const filter = "";
    const showmodalref = ref(false);
    let loading1 = ref(false);
    let title = "Unit Master";
    const showDialog = ref(false);
    let List: any = ref([]);
    const selectedItem = ref();
    const data = ref([]);
    const editItems = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const rowFocus = ref(false);
    const ObjData = ref();

    const popup = ref({
      activatepop: false,
      inactivepop: false,
    });

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    let content = ref("");
    let loading = ref(false);
    const dataEdit = ref();
    let ExportOption = ref("");
    let ExportList = ref([]);

    const toast = useToast();

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };


    const headers = [
      {
        header: t('Items.SurgeryBrandModelMaster.sno'),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t('Items.SurgeryBrandModelMaster.Name'),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('Items.SurgeryBrandModelMaster.BrandCount'),
        field: "BrandCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('Items.SurgeryBrandModelMaster.ModelCount'),
        field: "ModelCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('Items.SurgeryBrandModelMaster.Status'),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "Status",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: List },
      BrandCount: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ModelCount: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };

    const menu = ref();
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    let Editvisible = ref(false);

    const toggle = (event, data) => {
      debugger;
      ObjData.value = data;
      if (data.IsActive == 1) {
        Activevisible.value = false;
        InActivevisible.value = true;
        Editvisible.value = true;
      } else if (data.IsActive == 0) {
        Activevisible.value = true;
        InActivevisible.value = false;
        Editvisible.value = false;
      }
      menu.value.toggle(event);
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(ObjData);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(ObjData, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(ObjData, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(ObjData, 2);
            },
          },
        ],
      },
    ]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await service.List();
        let count = 0;
        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;
            return item;
          });

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    onMounted(() => {
      debugger;
      window.addEventListener("resize", handleResize);

      FunctionRights();
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    function RowClick(event: any) {
      debugger;
      rowFocus.value = true;
    }

    function IsAdd() {
      //
      debugger;
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function closemapping() {
      MappingPopup.value = false;
      Deletemodel.value = false;
    }
    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmDel(data, status) {
      //
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = false;
        Deletemodel.value = true;

        data.ActiveStatus = status;
        if (status == 1) {
          content.value = "Activate";
        } else if (status == 2) {
          content.value = "InActivate";
        } else {
          content.value = t('confirmation.deletecontent');
        }
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      popup.value.activatepop = false;
      popup.value.inactivepop = false;
    }

    //Table List
    async function IsShow() {
      debugger;
      try {
        loading.value = true;
        const response = await service.List();
        let count = 0;
        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;
            return item;
          });
        List.value = response["result"];
        console.log(List.value);
        loading.value = false;
      } catch (error) {
        alert(error);
        loading.value = false;

      }
    }

    //Row Edit
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      Editmodel.value = false;
    }

    //Row Delete
    async function IsDelete(data) {
      debugger;
      loading.value = true;
      const DelID = data.value.Id;
      try {
        data.ActiveStatus;
        let response: any = "";
        if (data.ActiveStatus == 0) {
          response = await service.Delete(DelID);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          response = await service.Active(DelID, status);
        }
        loading.value = false;

        let message = response["ErrorInfo"].ErrorCode;
        if (response["result"] != "False" && message == null) {
          Deletemodel.value = false;
          ContentName.value = response["result"];
          MappingPopup.value = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            popup.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            popup.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    }

    return {
      EntityData,
      ObjOperationId,
      ContentName,
      MappingPopup,
      headers,
      showmodalref,
      showpopModal: showmodalref,

      title,
      filter,
      loading1,
      List,
      filters,
      globalFilterFields,
      filteredColumns,
      showDialog: showDialog,
      selectedItem,
      data,
      closemapping,
      IsEdit,
      IsDelete,
      IsShow,
      RowClick,
      IsAdd,
      IsConfirmEdit,
      IsConfirmDel,
      closetrigger,
      Editmodel,
      editItems,
      Deletemodel,
      deletepop,
      dataEdit,
      loading,
      popup,
      menu,
      content,
      itemListed,
      toggle,
      Rights,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>
<style lang="scss" scoped>
.mobileroomname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}
</style>
